export default __webpack_public_path__ + "static/thedesignerfoundry-28a5461bcb8bf2d944b1e9f0458c9828.svg";